import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

// ── DTOs ──

export interface NextActionDTO {
  label: string;
  path: string;
  variant: 'primary' | 'secondary';
}

export interface ActivityDTO {
  id: string;
  action: string;
  table_name: string;
  actor_nombre: string | null;
  description: string;
  created_at: string;
}

export interface ProjectSummaryDTO {
  current_state: string;
  next_actions: NextActionDTO[];
  has_proforma: boolean;
  has_ot: boolean;
  proforma_id: string | null;
  proforma_estado: string | null;
  planillas_count: number;
  pedidos_count: number;
  pagos_total: number;
  total_proforma: number;
  total_ejecutado_proforma: number;
  porcentaje_ejecucion_proforma: number;
  recent_activity: ActivityDTO[];
}

// ── Hook ──

export function useProjectSummary(projectId: string) {
  return useQuery({
    queryKey: queryKeys.projectSummary.detail(projectId),
    queryFn: async () => {
      const response = await api.get<{ data: ProjectSummaryDTO }>(`/projects/${projectId}/summary`);
      return response.data.data;
    },
    enabled: !!projectId,
  });
}
